import { Component } from '@angular/core';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';

@Component({
    selector: 'gl-max-loads-popup',
    templateUrl: './max-loads-popup.component.html',
    styleUrls: ['./max-loads-popup.component.scss'],
    standalone: false
})
export class MaxLoadsPopupComponent {
  constructor(
    private modalRef: ModalOverlayRef,
  ) {
    this.modalRef.backgroundClicked();
  }

  public close(): void {
    this.modalRef.close();
  }
}
